import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCardControls } from '../../../redux/ChartPoperties/ChartControlsActions';
import ChartColors from './ChartColors';
import { OrientationRadioGroup } from '../Legend/LegendComponents/OrientationRadioGroup';
import { RootState } from '../../../redux';
import ColorPickerPopover from './ChartColorComponents/ColorPickerPopover';

const SimpleCardColors = ({ iconColor }: { iconColor?: string }) => {
  const dispatch = useDispatch();

  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const cardStyleOptions = chartControls.properties[propKey].cardControls;
  const isManualMode = cardStyleOptions.manualColor;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedItem, setSelectedItem] = useState<string>('');
  const [selectedColor, setSelectedColor] = useState<string>('');

  const handleColorChange = (color: string) => {
    dispatch(updateCardControls(propKey, selectedItem, color));
    setSelectedColor(color);
  };

  const renderSmallColorBox = (currentColor: string, itemKey: string) => (
    <div
      style={{
        height: '1rem',
        width: '30px',
        minWidth: '30px',
        backgroundColor: currentColor,
        border: '1px solid darkgray',
        cursor: 'pointer',
        borderRadius: '2px',
        marginRight: '10px',
      }}
      onClick={(e) => {
        setSelectedItem(itemKey);
        setSelectedColor(currentColor);
        setAnchorEl(e.currentTarget);
      }}
    />
  );

  return (
    <div style={{ marginTop: '20px', paddingTop: '8px', paddingLeft: '4px' }}>
      <OrientationRadioGroup
        orientation={isManualMode ? 'manual' : 'auto'}
        options={[
          { name: 'Auto', key: 'auto' },
          { name: 'Manual', key: 'manual' },
        ]}
        onChange={(key) => {
          dispatch(updateCardControls(propKey, 'manualColor', key === 'manual'));
        }}
        style={{ width: '94%' }}
      />

      <div>
        {isManualMode ? (
          <>
            <div
              className="optionDescription"
              style={{
                marginTop: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              {renderSmallColorBox(cardStyleOptions.valueColor, 'valueColor')}
              <label style={{ fontSize: '12px', color: iconColor ? iconColor : '#404040' }}>
                Value Color
              </label>
            </div>

            <div
              className="optionDescription"
              style={{
                marginTop: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              {renderSmallColorBox(cardStyleOptions.labelColor, 'labelColor')}
              <label style={{ fontSize: '12px', color: iconColor ? iconColor : '#404040' }}>
                Label Color
              </label>
            </div>

            <div
              className="optionDescription"
              style={{
                marginTop: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              {renderSmallColorBox(cardStyleOptions.bgColor, 'bgColor')}
              <label style={{ fontSize: '12px', color: iconColor ? iconColor : '#404040' }}>
                Background Color
              </label>
            </div>

            <ColorPickerPopover
              isOpen={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              currentColor={selectedColor}
              onColorChange={handleColorChange}
              propKey={propKey}
              selectedMenu=""
            />
          </>
        ) : (
          <div style={{ marginTop: '-15px' }}>
            <ChartColors iconColor={iconColor} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleCardColors;
